import React from 'react';
import { cn } from '@/utils/cn';

export interface TutaraBadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: 'default' | 'secondary' | 'success' | 'warning' | 'error' | 'outline' | 'destructive' | 'info';
  size?: 'sm' | 'md' | 'lg';
}

export const TutaraBadge = React.forwardRef<HTMLSpanElement, TutaraBadgeProps>(
  ({ className, variant = 'default', size = 'md', ...props }, ref) => {
    // Map 'destructive' to 'error' for consistency
    const normalizedVariant = variant === 'destructive' ? 'error' : variant;

    const variants = {
      default: 'bg-tutara-turquoise/10 dark:bg-teal-900/30 text-tutara-teal dark:text-teal-300 border-tutara-turquoise/20 dark:border-teal-800',
      secondary: 'bg-gray-100 dark:bg-gray-800 text-tutara-charcoal dark:text-gray-200 border-gray-200 dark:border-gray-700',
      success: 'bg-green-100 dark:bg-green-900/20 text-green-700 dark:text-green-400 border-green-200 dark:border-green-800',
      warning: 'bg-yellow-100 dark:bg-yellow-900/20 text-yellow-700 dark:text-yellow-400 border-yellow-200 dark:border-yellow-800',
      error: 'bg-red-100 dark:bg-red-900/20 text-red-700 dark:text-red-400 border-red-200 dark:border-red-800',
      outline: 'bg-transparent text-tutara-charcoal dark:text-gray-100 border-gray-300 dark:border-gray-600',
      info: 'bg-blue-100 dark:bg-blue-900/20 text-blue-700 dark:text-blue-400 border-blue-200 dark:border-blue-800',
    };

    const sizes = {
      sm: 'px-2 py-0.5 text-xs',
      md: 'px-2.5 py-0.5 text-xs',
      lg: 'px-3 py-1 text-sm',
    };

    return (
      <span
        ref={ref}
        className={cn(
          'inline-flex items-center rounded-full font-medium border',
          variants[normalizedVariant],
          sizes[size],
          className
        )}
        {...props}
      />
    );
  }
);

TutaraBadge.displayName = 'TutaraBadge';